import { Typography, Grid2 } from "@mui/material";
import { Link } from "react-router-dom";
import CommonRegisterForm from "../../feature/Login/skillvationLogins/CommonSKillVationRegisterForm";

const SchoolRegisterForm = () => {
  const bottomLine = (
    <Grid2 size={12} display="flex" justifyContent="center" gap={0.5}>
      <Typography variant="body2" fontSize="12px">
        Already have an account !!
      </Typography>
      <Link to="/login">
        <Typography variant="body2" fontSize="12px" color="primary.main">
          Sign In
        </Typography>
      </Link>
    </Grid2>
  );

  return (
    <CommonRegisterForm
      signupRoute="schools/signup"
      loginRoute="schools/login"
      bottomLine={bottomLine}
      role={'school'}
    />
  );
};

export default SchoolRegisterForm;